import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";

const NavBarContainer = styled.nav`
  width: 100%;
  background: #fff;
  padding: 10px 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`;

const NavLinks = styled.ul`
  display: flex;
  gap: 30px;
  list-style: none;
  margin: 0;
  padding: 0;
  justify-content: center;
  align-items: center;
`;

const NavItem = styled.li``;

const NavLinkStyled = styled(Link)`
  text-decoration: none;
  color: #000;
  font-weight: bold;
  font-size: 18px;
  transition: color 0.2s ease-in-out;

  &:hover {
    color: #0d2b3e;
  }
`;

function NavigationBar() {
  return (
    <NavBarContainer>
      <NavLinks>
        <NavItem>
          <NavLinkStyled to="/">Home</NavLinkStyled>
        </NavItem>
        <NavItem>
          <NavLinkStyled to="/fleet">Fleet</NavLinkStyled>
        </NavItem>
        <NavItem>
          <NavLinkStyled to="/reservations">Reservations</NavLinkStyled>
        </NavItem>
        <NavItem>
          <NavLinkStyled to="/faq">FAQs</NavLinkStyled>
        </NavItem>
        <NavItem>
          <NavLinkStyled to="/contact">Contact</NavLinkStyled>
        </NavItem>
      </NavLinks>
    </NavBarContainer>
  );
}

export default NavigationBar;
